module.exports = "<svg viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M.702 14.635C2.997 6.115 10.665 0 20 0c11.2 0 20 8.8 20 20s-8.8 20-20 20C10.383 40 2.536 33.512.51 24.588h18.42v6.635L30.54 19.61 18.93 8v6.635H.7z\" fill=\"#13DDB0\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/icons/forward-to-icon.svg
// module id = ZWSh
// module chunks = 89